;(() => {
  const productsHeader = document.querySelector('header.products-grid-header')
  if (productsHeader) {
    const url = new URL(window.location.href)
    const htmlElement = document.querySelector('html')
    const toggleCollections = document.getElementById('toggle-collections')
    const toggleProductList = document.getElementById('toggle-product-list')
    const themedCollections = document.getElementById('themed-collections')
    const collectionProducts = document.getElementById('collection-products')
    const productsGrid = document.querySelector('section.products .grid')
    const toggleGridButton = document.getElementById(
      'products-toggle-layout-masonry'
    )
    const toggleMiniButton = document.getElementById(
      'products-toggle-layout-mini'
    )

    // Toggle between collections and products
    const toggleView = (showProducts) => {
      toggleCollections.classList.toggle('active', !showProducts)
      toggleProductList.classList.toggle('active', showProducts)
      themedCollections.hidden = showProducts
      collectionProducts.hidden = !showProducts
      htmlElement.classList.toggle('view-products', showProducts)

      if (showProducts) {
        url.searchParams.set('view', 'products')
      } else {
        url.searchParams.delete('view')
      }

      window.history.replaceState({}, '', url)
    }

    toggleCollections?.addEventListener('click', () => toggleView(false))
    toggleProductList?.addEventListener('click', () => toggleView(true))

    //initial view
    if (url.searchParams.get('view') === 'products' || !themedCollections) {
      toggleProductList?.click()
      htmlElement.classList.add(`view-products`)
    } else {
      htmlElement.classList.add(`view-collections`)
    }

    const toggleLayout = (useMasonry) => {
      toggleGridButton.classList.toggle('active', useMasonry)
      toggleMiniButton.classList.toggle('active', !useMasonry)
      productsGrid.classList.replace(
        useMasonry ? 'layout-mini' : 'layout-masonry',
        useMasonry ? 'layout-masonry' : 'layout-mini'
      )

      localStorage.setItem(
        'product-grid-layout',
        useMasonry ? 'masonry' : 'grid'
      )
    }

    //persist setting to localStorage
    const productGridLayoutSetting =
      localStorage.getItem('product-grid-layout') || 'masonry' //set default to masonry, if localStorage is undefined
    toggleLayout(productGridLayoutSetting === 'masonry')
    toggleGridButton?.addEventListener('click', () => toggleLayout(true))
    toggleMiniButton?.addEventListener('click', () => toggleLayout(false))
  }

  const stickyElement = document.querySelector('.products-grid-header')
  const stickyHelper = document.getElementById(
    'products-grid-header-sticky-helper'
  )

  if (stickyElement) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyElement.classList.toggle('stuck', entry.boundingClientRect.y < 0)
      },
      {
        threshold: [0],
        rootMargin: `0px 0px 0px 0px`
      }
    )

    observer.observe(stickyHelper)
  }
})()
